import { render, staticRenderFns } from "./EventDetails.vue?vue&type=template&id=36a7f59f&scoped=true&lang=pug"
import script from "./EventDetails.vue?vue&type=script&lang=ts"
export * from "./EventDetails.vue?vue&type=script&lang=ts"
import style0 from "./EventDetails.vue?vue&type=style&index=0&id=36a7f59f&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a7f59f",
  null
  
)

export default component.exports